export const onEnterPressed = (e, func) => {
  if (e.key === "Enter") {
    func();
  }
}